import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.EntryChange', null, 2);
        tmp0_serialDesc.a1b('old', true);
        tmp0_serialDesc.a1b('new', true);
        this.p3l_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer().m3o(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static z3y() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.EntryChange', $this, 2);
        tmp0_serialDesc.a1b('old', true);
        tmp0_serialDesc.a1b('new', true);
        $this.k3o_1 = tmp0_serialDesc;
        return $this;
      }
      a3z(encoder, value) {
        var tmp0_desc = this.k3o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.b3z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, this.l3o_1, value.b3z_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.c3z_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, this.l3o_1, value.c3z_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a3z(encoder, value instanceof EntryChange() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k3o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, this.l3o_1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, this.l3o_1, tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, this.l3o_1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, this.l3o_1, tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EntryChange().d3z(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.k3o_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(this.l3o_1), get_nullable(this.l3o_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.l3o_1];
      }
      static m3o(typeSerial0) {
        var $this = this.z3y();
        $this.l3o_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var EntryChangeClass;
function EntryChange() {
  if (EntryChangeClass === VOID) {
    class $ {
      constructor(old, new_0) {
        Companion_getInstance();
        old = old === VOID ? null : old;
        new_0 = new_0 === VOID ? null : new_0;
        this.b3z_1 = old;
        this.c3z_1 = new_0;
      }
      toString() {
        return 'EntryChange(old=' + toString(this.b3z_1) + ', new=' + toString(this.c3z_1) + ')';
      }
      hashCode() {
        var result = this.b3z_1 == null ? 0 : hashCode(this.b3z_1);
        result = imul(result, 31) + (this.c3z_1 == null ? 0 : hashCode(this.c3z_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EntryChange()))
          return false;
        if (!equals(this.b3z_1, other.b3z_1))
          return false;
        if (!equals(this.c3z_1, other.c3z_1))
          return false;
        return true;
      }
      static d3z(seen0, old, new_0, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().p3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.b3z_1 = null;
        else
          $this.b3z_1 = old;
        if (0 === (seen0 & 2))
          $this.c3z_1 = null;
        else
          $this.c3z_1 = new_0;
        return $this;
      }
    }
    initMetadataForClass($, 'EntryChange', EntryChange, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    EntryChangeClass = $;
  }
  return EntryChangeClass;
}
//region block: exports
export {
  $serializer as $serializer3hxquo1mpwg0w,
  Companion_getInstance as Companion_getInstance2cg5mffg7iayj,
};
//endregion

//# sourceMappingURL=EntryChange.mjs.map
